
function myCommChange(params) {


var oldPicture=document.querySelector(".css-178dpdj");

if(oldPicture === null || typeof oldPicture === null){
  
  setTimeout(myCommChange,4000)
}else{

//oldPicture.querySelector("svg").remove();


oldPicture.style.width="70px";
oldPicture.style.height="70px";
oldPicture.style.flexDirection="column";
oldPicture.style.backgroundColor="#81d8d0";


var spanElement = document.createElement("span");

var spanElementText = document.createElement("span");

spanElementText.innerHTML="Contact";
spanElementText.style.position="relative";
spanElementText.style.fontSize="13px";
spanElementText.style.color="#000";
spanElementText.style.fontFamily="Santral W01";
spanElementText.style.fontWeight="600";


spanElement.style.display = "inline-block";
spanElement.style.width = "30px";
spanElement.style.height = "30px";
spanElement.style.backgroundRepeat="no-repeat";
spanElement.style.backgroundSize="29px";
spanElement.style.backgroundImage = "url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMiAwSDE2djJoN3Y4LjAyNUMxMi40MTkgMTAuNTQ1IDQgMTkuMjkgNCAzMHY0aDQwdi00YzAtMTAuNzEtOC40MTktMTkuNDU0LTE5LTE5Ljk3NVYyaDdWMHptMTAgMzBjMC05Ljk0MS04LjA1OS0xOC0xOC0xOFM2IDIwLjA1OSA2IDMwdjJoMzZ2LTJ6bTYgMTZ2Mkgwdi0yaDF2LS4yOTdMNS40MjQgMzloMzcuMTAybDQuNDY2IDYuN3YuM0g0OHptLTMuMjEyIDBsLTMuMzMyLTVINi41bC0zLjMgNWg0MS41ODd6IiBmaWxsPSIjMDAwIi8+PG1hc2sgaWQ9ImEiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzIgMEgxNnYyaDd2OC4wMjVDMTIuNDE5IDEwLjU0NSA0IDE5LjI5IDQgMzB2NGg0MHYtNGMwLTEwLjcxLTguNDE5LTE5LjQ1NC0xOS0xOS45NzVWMmg3VjB6bTEwIDMwYzAtOS45NDEtOC4wNTktMTgtMTgtMThTNiAyMC4wNTkgNiAzMHYyaDM2di0yem02IDE2djJIMHYtMmgxdi0uMjk3TDUuNDI0IDM5aDM3LjEwMmw0LjQ2NiA2Ljd2LjNINDh6bS0zLjIxMiAwbC0zLjMzMi01SDYuNWwtMy4zIDVoNDEuNTg3eiIgZmlsbD0iI2ZmZiIvPjwvbWFzaz48ZyBtYXNrPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMDAwIiBkPSJNMCAwaDQ4djQ4SDB6Ii8+PC9nPjwvc3ZnPg==)";

oldPicture.appendChild(spanElement);
oldPicture.appendChild(spanElementText);

}

}

function winLoad(callback) {
    if (document.readyState === 'complete') {
      callback();
    } else {
      window.addEventListener("load", callback);
    }
}

winLoad(function() {

  myCommChange();
 countryCode();

});



function countryCode(params) {
  $('#country_code_label').change(function(){
    var text = $(this).find('option:selected').text()
    var $aux = $('<select/>').append($('<option/>').text(text))
    $(this).after($aux)
    $(this).css('width',($aux.width() * 1.6)  + 'px' ); 
    $aux.remove()
}).change();
}

document.addEventListener('DOMContentLoaded', function() {
const swatchElements = document.querySelectorAll(".option2 .swatch-element");

const show_color_types=document.querySelector(".option2 .show_color_types");

if(swatchElements && show_color_types){
     const firstSwatchElement = swatchElements[0];
     const dataValue = firstSwatchElement.getAttribute('data-value');
     show_color_types.innerHTML = dataValue;
  
    swatchElements.forEach((element) => {
    element.addEventListener('click', (e) => {
        let dataValue = e.currentTarget.getAttribute('data-value');
        show_color_types.innerHTML=dataValue;
        
    });
});

}
});




const sliders = document.querySelectorAll('.collection .grid .grid__item .sliderre');

// console.log("sliders",sliders);
sliders.forEach((slider, index) => {
  let currentSlide;
// console.log("slider",slider)
  slider.addEventListener('mouseenter', function () {
    console.log("enter")
    currentSlide = $(this).slick('slickCurrentSlide');
    $(this).slick('slickNext');
  });

  slider.addEventListener('mouseleave', function () {
    console.log("exit")
    $(this).slick('slickGoTo', currentSlide);
  });
});


